export const mapReleaseTypeSpeakerToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfRelease: item.releaseSpeakerVersions?.length,
  }));

  return result;
};

export const typeSpeakerColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "typeSpeaker", label: "Type Speaker", align: "center" },
  { key: "numOfRelease", label: "Num Of Release Version", align: "center" },
];
